import React from 'react';
import profileImg from '../../Assets/kjszprof.jpg';
import { useTranslation } from 'react-i18next';

const Impresszum = () => {
    const { t } = useTranslation();
    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
            <h1>{t('Footer.Imprint')}</h1>

            <img
                src={profileImg}
                alt="dr. Kovács József-Szilamér"
                style={{
                    maxWidth: '200px',
                    width: '100%',
                    float: 'right',
                    marginLeft: '20px',
                    marginBottom: '10px',
                    borderRadius: '4px'
                }}
            />
            <p>{t('Imprint.Intro')}</p>
            <p>
                {t('Imprint.ProducedBy')}
                <strong> dr. Kovács József Szilamér </strong> {t('Imprint.AndThe')}
                <strong> {t('Imprint.SNP')}</strong>.
            </p>

            <p>
                <strong>{t('Imprint.ResponsiblePublisher')}:</strong><br />
                dr. Kovács József-Szilamér
            </p>

            <h4>{t('Imprint.EditorialOffice')}:</h4>
            <p>Sepsiszentgyörgy, Gesztenye utca, 4/B/3</p>

            <p><strong>{t('Imprint.Phone')}:</strong> +40 742 068 177</p>
            <p><strong>{t('Imprint.Email')}:</strong> adm.szno"kukac"gmail.com</p>
        </div>
    );
};

export default Impresszum;
